<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary"
                >الصفحة الرئيسية</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الدروس الخاصة</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button
            @click="$router.go(-1)"
            class="btn btn-light"
            style="
              font-weight: 600;
              padding: 8px 20px;
              margin-left: 15px;
              background: #d7d7d745;
            "
          >
            رجوع
            <i
              class="fa fa-arrow-left"
              style="color: #07c232; margin-right: 10px"
            ></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isLoading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار</h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div
            class="col-md-12"
            v-if="isLoading == false && isLoggedIn == true"
          >
            <div class="row">
              <div class="col-xl-12">
                <PendingSessionsList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import PendingSessionsList from "./pending.vue";

export default {
  name: "SessionsList",
  components: {
    PendingSessionsList,
  },
  data() {
    return {
      /* --------- قائم كما هو --------- */
      categoriesData: [],
      selectedCategoryId: null,
      selectedSubCategoryId: null,
      selectedChildCategoryId: null,
      isLoading: true,
      slotsLoading: false,
      isLoggedIn: false,
      token: localStorage.getItem("access_token"),

      /* --------- جديد --------- */
      instructors: [], // البيانات التى سنعرضها
      pagerLinks: {}, // prev / next / first / last
      pagerMeta: {}, // current_page, links[], ...
      instructorImgPath: baseUrl + "/images/instructors/", // عدِّل المسار إذا لزم

      /* أي شيء آخر */
      defaultImage: "/assets/img/acad-icon.png",
    };
  },

  computed: {
    /** التخصصات حسب الفئة المختارة */
  },

  mounted() {
    this.getCategories();
  },

  methods: {
    /** جلب الفئات من الـAPI */
    async getCategories() {
      this.isLoading = true;
      try {
        const res = await fetch(`${apiUrl}/live-sessions/get-categories`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (res.ok) {
          this.isLoggedIn = true;
          var categoriesDataResponse = await res.json();

          this.categoriesData = categoriesDataResponse.categories;
        } else {
          console.error("Failed to fetch categories");
        }
      } catch (e) {
        console.error("Error fetching categories:", e);
      } finally {
        this.isLoading = false;
      }
    },

    /* ---------- مساعدات صغيرة للعرض ---------- */
  },
};
</script>

<style scoped>
.swal2-container.no-flex-swal {
  display: block !important;
  text-align: center;
}

/* المودال نفسه */
.no-flex-swal {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
</style>
